export const messages = {
  en: {
    queryWarnStock: {
      searchCondition: 'Search Condition',
      stockQuery: 'Stock Query',
      warehouse: 'Warehouse',
      productName: 'Product Name',
      productId: 'Product ID',
      productSpec: 'Product Specification',
      stock: 'Stock',
      warnStock: 'Warn Stock',
      search: 'Search',
      reset: 'Reset'
    }
  },
  zh: {
    queryWarnStock: {
      searchCondition: '查询条件',
      stockQuery: '库存查询',
      warehouse: '仓库',
      productName: '商品名称',
      productId: '商品编号',
      productSpec: '商品规格',
      stock: '库存',
      warnStock: '库存警告',
      search: '查询',
      reset: '重置'
    }
  }
}